import { render, staticRenderFns } from "./TsTable.vue?vue&type=template&id=7dd42e0c&"
import script from "./TsTable.vue?vue&type=script&lang=js&"
export * from "./TsTable.vue?vue&type=script&lang=js&"
import style0 from "./TsTable.vue?vue&type=style&index=0&id=7dd42e0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports